<template>
    <div
        class="md-house layout6 mg-bg"
        :style="{ ...spaceStyle, ...colorStyle, background: bgColor }"
        v-if="result && result.listings && result.listings.length > 0"
    >
        <div class="house-container f-col" :class="{ pc: !isMobileSize }">
            <div class="title-wrap">
                <site-title
                    :title="title"
                    class="house-title"
                />
                <site-sub-title
                    class="desc"
                    :size="16"
                    :mbSize="16"
                    :title="desc"
                />
            </div>
            <list />
            <div class="btn-box">
                <div class="button-swiper" v-if="showSwiperBtn">
                    <div class="house-prev layout6">
                        <i class="iconfont icon-arrow-up prev-el"></i>
                    </div>
                    <div class="house-next layout6">
                        <i class="iconfont icon-arrow-up next-el"></i>
                    </div>
                </div>
                <site-button
                    v-if="moreShow && moreText"
                    :html="moreText"
                    class="view-all-listings-btn"
                    :href="moreLink"
                    :aria-label="moreLinkPurpose"
                    rel="noopener noreferrer"
                />
            </div>
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>
<script>
import Core from '../index.js';
import list from './list.vue';
export default {
    mixins: [Core],
    components: { list },
    computed: {
        showSwiperBtn() {
            let len = this.result.listings.length;
            if (this.isMobileSize) {
                return false;
            }
            // if (window.innerWidth > 1000) {
            return len > 4;
            // } else {
            //     return len > 3;
            // }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-house.layout6 {
    .house-container {
        position: relative;

        .title-wrap {
            margin-bottom: 40px;
            .desc {
                margin-top: 10px;
                
            }
            @include media-800 {
                margin-bottom: 20px;
            }
        }
    }
    .swiper {
        height: 520px;
        .swiper-wrapper {
            .swiper-slide {
                // width: 350px;
                width: 25%;
                height: 400px;
                padding-left: 15px;
                transition: all 0.3s cubic-bezier(0.4, 0, 1, 1);
                &.swiper-slide-active{
                    height: 520px;
                    padding-right: 35px;
                    padding-left: 0;
                }
            }
            .swiper-slide.swiper-slide-active {
                .house-slider-item.layout6 {
                    border: none;
                    padding: 0;
                    > article {
                        position: relative;
                    }
                    .house-imgs {
                        height: 100%;
                    }
                    .house-info {
                        justify-content: flex-end;
                        height: 266px;
                        padding: 20px;
                        background: linear-gradient(
                            180deg,
                            rgba(25, 25, 25, 0) 0%,
                            rgba(25, 25, 25, 0.8) 100%
                        );
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        z-index: 2;
                        color: #fff;
                        pointer-events: none;

                        .house-price-wrap {
                            .house-sold-price,
                            .house-price {
                                color: #fff;
                            }
                            .house-initial-price {
                                color: rgba(255, 255, 255, 0.7);
                            }
                        }
                        .address,
                        .detail {
                            margin-top: 10px;
                            color: rgba(255, 255, 255, 0.8);
                        }
                        .detail {
                            .vertical-line:after {
                                color: rgba(255, 255, 255, 0.8);
                            }
                        }

                        .mls-box {
                            .house-mls-id,
                            .desc {
                                color: rgba(255, 255, 255, 0.5);
                            }
                        }
                    }
                }
            }
            .swiper-slide.house-placeholder {
                .house-slider-item.layout6 {
                    .house-imgs {
                        background: rgba(218, 218, 218, 0.2);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img {
                            width: 64px;
                            height: 56px;
                            &:hover {
                                transform: scale(1);
                            }
                        }
                    }
                    .house-info {
                        div {
                            background: rgba(218, 218, 218, 0.2);
                        }
                        .house-price-wrap {
                            height: 30px;
                        }
                        .detail,
                        .address {
                            width: calc(100% - 60px);
                            height: 20px;
                            margin-top: 10px;
                        }
                        .mls-box {
                            height: 15px;
                            margin-top: 20px;
                        }
                    }
                }
            }
        }
    }
    @include media-800 {
        .swiper {
            height: auto;
            .swiper-wrapper {
                align-items: stretch;
                .swiper-slide {
                    width: 305px;
                    height: auto;
                    padding-left: 0;
                    &.swiper-slide-active {
                        height: auto;
                        padding-right: 0;
                        padding-left: 0;
                    }
                }
                .swiper-slide,
                .swiper-slide.swiper-slide-active {
                    .house-slider-item.layout6 {
                        border: 1px solid rgba(218, 218, 218, 0.5);
                        border-radius: 0;
                        padding: 16px;
                        height: 100%;
                        > article {
                            position: static;
                            height: 100%;
                        }
                        .house-imgs {
                            height: 224px;
                        }
                        .house-info {
                            position: static;
                            height: auto;
                            flex: 1;
                            padding: 15px 0 0 0;
                            background: none;
                            pointer-events: auto;
                            .house-price-wrap {
                                .title-mask-v2 {
                                    font-size: 24px;
                                }
                                .house-sold-price,
                                .house-price {
                                    color: var(--g-primary-color);
                                }
                                .house-initial-price {
                                    color: var(--g-tip-color);
                                }
                            }
                            .address,
                            .detail {
                                margin-top: 5px;
                                color: var(--g-text-color);
                                font-size: 14px;
                                line-height: 21px;
                            }
                            .detail .vertical-line:after {
                                color: var(--g-text-color);
                            }
                            .mls-box {
                                margin-top: auto;
                                .house-mls-id,
                                .desc {
                                    color: var(--g-tip-color);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .btn-box {
        width: calc(75% - 15px);
        height: 50px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 10;

        .button-swiper {
            float: left;
            width: 130px;
            height: 50px;
            display: flex;
            justify-content: space-between;
            .house-next,
            .house-prev {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                border: 1px solid var(--g-btn-background);
                display: flex;
                align-items: center;
                justify-content: center;
                color: var(--g-btn-background);
                transform: rotate(90deg);
                cursor: pointer;
                .iconfont {
                    font-size: 20px;
                }
                &:hover::after {
                    content: '';
                    background: rgba(25, 25, 25, 0.1);
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
                &.house-swiper-disabled,
                &.swiper-button-lock {
                    cursor: not-allowed;
                    opacity: 0.3;
                    &:hover::after {
                        content: '';
                        background: transparent;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }
                &.house-prev {
                    transform: rotate(-90deg);
                    margin-right: 30px;
                }
            }
        }
        .view-all-listings-btn {
            float: right;
            text-align: center;
            color: var(--g-btn-color);
            background: var(--g-btn-background);
            height: 50px;
            line-height: 50px;
            width: 200px;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 0 15px;
            box-sizing: border-box;
            cursor: pointer;
            font-size: 16px;
            font-weight: 500;
        }

        @include media-800 {
            width: 100%;
            height: auto;
            position: static;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 20px;
            .view-all-listings-btn {
                float: none;
                margin: 0 auto;
            }
        }
    }
}
</style>
